module.exports = __webpack_public_path__ + "static/media/herramientas.0fdd314e.png";